import React from 'react';

const EnvVarsFeaturesContext = React.createContext({
  features: {},
  envVars: {},
});

export default EnvVarsFeaturesContext;
